import { render } from "./ScratchGame.vue?vue&type=template&id=ed56d3ba&scoped=true"
import script from "./ScratchGame.vue?vue&type=script&lang=js"
export * from "./ScratchGame.vue?vue&type=script&lang=js"

import "./ScratchGame.vue?vue&type=style&index=0&id=ed56d3ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed56d3ba"]])

export default __exports__